import React, { useEffect, useState } from "react";
import { MortgageProps } from '../contexts/MortgageContextProvider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faList } from '@fortawesome/free-solid-svg-icons'

type ChildProps = {
    mortgageState: MortgageProps,
    secondMortgageState: MortgageProps,
    compareTwo: boolean,
    effectiveInterestRate: string,
    effectiveInterestRateTwo: string
};

const formatCurrency = (amount: number) => {
    const pounds = Math.floor(amount);
    const pennies = Math.round((amount - pounds) * 100);
    return { pounds, pennies: pennies < 10 ? `0${pennies}` : pennies };
};

const MortgageSummary = ({ title, state, effectiveInterestRate }: { title: string, state: MortgageProps, effectiveInterestRate: string }) => {
    const { pounds: repaymentPounds, pennies: repaymentPennies } = formatCurrency(state.monthlyPayment ? Math.round(state.monthlyPayment * 100) / 100 : 0);
    const { pounds: mortgagePounds, pennies: mortgagePennies } = formatCurrency(state.totalAmountPaid ? Math.round(state.totalAmountPaid * 100) / 100 : 0);
    const { pounds: interestPounds, pennies: interestPennies } = formatCurrency(state.totalInterest ? Math.round(state.totalInterest * 100) / 100 : 0);

    return (
        <>
            <h2 className="text-xl font-bold"><FontAwesomeIcon icon={faList} className="mr-2" />{title}</h2>
            <p className="text-xl font-medium">Interest Rate: <span className="font-bold">{effectiveInterestRate}%</span></p>
            <p className="text-xl font-medium">Repayments: <span className="font-bold">£{repaymentPounds}<span className="text-sm">.{repaymentPennies}</span></span></p>
            <p className="text-xl font-medium">Total Interest Paid: <span className="font-bold">£{interestPounds}<span className="text-sm">.{interestPennies}</span></span></p>
            <p className="text-xl font-medium">Total Mortgage Paid: <span className="font-bold">£{mortgagePounds}<span className="text-sm">.{mortgagePennies}</span></span></p>
        </>
    );
};

const MortgageSummaryStretched = ({ title, state, effectiveInterestRate }: { title: string, state: MortgageProps, effectiveInterestRate: string }) => {
    const { pounds: repaymentPounds, pennies: repaymentPennies } = formatCurrency(state.monthlyPayment ? Math.round(state.monthlyPayment * 100) / 100 : 0);
    const { pounds: mortgagePounds, pennies: mortgagePennies } = formatCurrency(state.totalAmountPaid ? Math.round(state.totalAmountPaid * 100) / 100 : 0);
    const { pounds: interestPounds, pennies: interestPennies } = formatCurrency(state.totalInterest ? Math.round(state.totalInterest * 100) / 100 : 0);

    return (
        <>
            <p className="text-xl font-medium">Interest Rate: <span className="font-bold">{effectiveInterestRate}%</span></p>
            <p className="text-xl font-medium">Repayments: <span className="font-bold">£{repaymentPounds}<span className="text-sm">.{repaymentPennies}</span></span></p>
            <p className="text-xl font-medium">Total Interest Charged: <span className="font-bold">£{interestPounds}<span className="text-sm">.{interestPennies}</span></span></p>
            <p className="text-xl font-medium">Total Mortgage Paid: <span className="font-bold">£{mortgagePounds}<span className="text-sm">.{mortgagePennies}</span></span></p>
        </>
    );
};

const SummaryBox = ({ mortgageState, secondMortgageState, compareTwo, effectiveInterestRate, effectiveInterestRateTwo }: ChildProps) => {
    const [compare, setCompare] = useState(false);
    useEffect(() => {
        setCompare(compareTwo);
    }, [mortgageState, secondMortgageState, compareTwo, effectiveInterestRateTwo]);

    return (
        <div className="grid bg-base-300 rounded-box p-3 w-full">
            <div className="flex flex-col md:flex-row justify-between items-stretch w-full">
                {compare ? (
                    <>
                        <div className="w-full md:w-1/2 space-y-2">
                            <MortgageSummary title="Mortgage 1" state={mortgageState} effectiveInterestRate={effectiveInterestRate} />
                        </div>
                        <div className='divider lg:divider-horizontal'></div>
                        <div className="w-full md:w-1/2 space-y-2">
                            <MortgageSummary title="Mortgage 2" state={secondMortgageState} effectiveInterestRate={effectiveInterestRateTwo} />
                        </div>
                    </>
                ) : (
                    <div className="w-full flex flex-col md:flex-row justify-between items-stretch space-x-4">
                        <MortgageSummaryStretched title="Mortgage Summary" state={mortgageState} effectiveInterestRate={effectiveInterestRate} />
                    </div>
                )}
            </div>
        </div>
    );
}

export default SummaryBox;
